import { useEffect } from 'react'

// Ab hier gibt es die feste Sidebar (Tailwind lg), darunter nur die mobile
const DESKTOP_QUERY = '(min-width: 1024px)'

const isEditable = (target) =>
  target instanceof HTMLElement &&
  (target.isContentEditable ||
    ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName))

/**
 * ⌘B bzw. Strg+B klappt die Sidebar ein und aus, wie bei Linear und shadcn.
 * In Eingabefeldern und Editoren gehört das Kürzel dem Feld (TipTap macht
 * damit fett), deshalb zählt es dort nicht.
 */
export const useSidebarShortcut = (onToggle) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key?.toLowerCase() !== 'b') return
      if (!(event.metaKey || event.ctrlKey) || event.shiftKey || event.altKey)
        return
      if (event.defaultPrevented || isEditable(event.target)) return
      if (!window.matchMedia(DESKTOP_QUERY).matches) return

      event.preventDefault()
      onToggle()
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [onToggle])
}
